/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Applicant,
  ApplicantCreatePayloadRequest,
  ErrorResponse,
  ValidationErrorResponse,
} from '../models';
import {
    ApplicantFromJSON,
    ApplicantToJSON,
    ApplicantCreatePayloadRequestFromJSON,
    ApplicantCreatePayloadRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface ApplicantsCreateRequest {
    applicantCreatePayloadRequest: ApplicantCreatePayloadRequest;
}

export interface ApplicantsDestroyRequest {
    id: number;
}

/**
 * 
 */
export class ApplicantsApi extends runtime.BaseAPI {

    /**
     */
    async applicantsCreateRaw(requestParameters: ApplicantsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Applicant>> {
        if (requestParameters.applicantCreatePayloadRequest === null || requestParameters.applicantCreatePayloadRequest === undefined) {
            throw new runtime.RequiredError('applicantCreatePayloadRequest','Required parameter requestParameters.applicantCreatePayloadRequest was null or undefined when calling applicantsCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/applicants/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicantCreatePayloadRequestToJSON(requestParameters.applicantCreatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicantFromJSON(jsonValue));
    }

    /**
     */
    async applicantsCreate(requestParameters: ApplicantsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Applicant> {
        const response = await this.applicantsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async applicantsDestroyRaw(requestParameters: ApplicantsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling applicantsDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/applicants/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async applicantsDestroy(requestParameters: ApplicantsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.applicantsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async applicantsListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Applicant>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/applicants/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicantFromJSON));
    }

    /**
     */
    async applicantsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Applicant>> {
        const response = await this.applicantsListRaw(initOverrides);
        return await response.value();
    }

}
